// These are excluded from the DataTables column selector.
// They are either always on or contextually activated/deactivated.
export const notSelectable = ["id", "user", "candidate", "outcome"];

export const defaultVisibilityByKind = {
  default: [
    "recorded",
    "user",
    "kind",
    "candidate",
    "duration",
    "timestamp",
    "campaign",
    "outcome",
  ],
  contact: ["recorded", "user", "kind", "duration", "timestamp", "outcome"],
};

export const columns = [
  {
    data: (x) => x,
    title: "",
    name: "id",
  },
  {
    data: (x) => x,
    name: "recorded",
    title: "",
    render: (call) => call.recorded,
  },
  {
    data: "user",
    name: "user",
    title: "User",
  },
  {
    data: "kind",
    name: "kind",
    title: "Direction",
    orderable: true,
  },
  {
    data: "candidate",
    name: "candidate",
    title: "Contact",
  },
  {
    data: "duration",
    name: "duration",
    title: "Duration",
    orderable: true,
  },
  {
    data: "timestamp",
    name: "timestamp",
    title: "Date",
    orderable: true,
  },
  {
    data: (x) => x,
    name: "campaign",
    title: "Campaign",
    orderable: true,
  },
  {
    data: (x) => x,
    name: "outcome",
    title: "Outcome",
    render: (outcomeId) => outcomeId,
    orderable: true,
  },
];
